import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { EyeOff } from "lucide-react";

export default function ImpersonationBanner() {
  const { user, impersonator, stopImpersonation } = useAuth();
  if (!impersonator || !user) return null;
  return (
    <div
      className="w-full bg-primary text-white text-sm py-2.5 px-6 flex items-center justify-between gap-4"
      data-testid="impersonation-banner"
    >
      <div className="flex items-center gap-2">
        <EyeOff className="w-4 h-4" />
        <span>
          Viewing as <span className="font-medium">{user.email}</span> · admin: {impersonator}
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={stopImpersonation}
        className="rounded-full bg-white/10 hover:bg-white/20 text-white border-white/30"
        data-testid="stop-impersonation"
      >
        Return to admin
      </Button>
    </div>
  );
}
